/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobItemResponse {
    getFixupPrototypeFunction() { return TemplateJobItemResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobItemResponse>): TemplateJobItemResponse {
        let obj = Object.assign(new TemplateJobItemResponse(), model);
        TemplateJobItemResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobItemResponse>): TemplateJobItemResponse {
        if (!model) return null;
        return TemplateJobItemResponse.newInstance(<TemplateJobItemResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobItemResponse) {
        if (!obj) return;

        models.TemplateJobItemResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobItemResponse): boolean {
        Object.setPrototypeOf(obj, TemplateJobItemResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.completed_at === "string") {
            this.completed_at = new Date(<string><any>this.completed_at);
        }
        if (this.resources) {
            for (let val of this.resources) {
                models.TemplateJobV2Resource.fixupPrototype(val);
            }
        }
        if (this.args) {
            for (let val of this.args) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
        if (this.service_accounts) {
            for (let val of this.service_accounts) {
                models.TemplateServiceAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique ID of the job
     */
    job_id: string;

    /**
     * Name of the job
     */
    name: string;

    /**
     * Overall status of the job
     */
    status: models.TemplateJobStatus;

    /**
     * Error message if failed
     */
    status_reason: string;

    /**
     * ID of the template this job executed
     */
    template_id: string;

    /**
     * The job's execution engine
     */
    engine_type: models.TemplateEngineType;

    /**
     * Parent job ID, if this job was spawned by another (batch fan-out or Terraform rerun)
     */
    parent_job_id: string;

    /**
     * Underlying Terraform/Heat stack identifier
     */
    stack_id: string;

    /**
     * Terraform state, if applicable
     */
    terraform_state: string;

    /**
     * Resources created/affected by this job
     */
    resources: Array<models.TemplateJobV2Resource>;

    /**
     * Arguments used for this job. Sensitive values are masked.
     */
    args: Array<models.NamedParameter>;

    /**
     * How this job was triggered
     */
    execution_type: models.TemplateExecutionType;

    /**
     * Service accounts used
     */
    service_accounts: Array<models.TemplateServiceAccount>;

    /**
     * Job output
     */
    output: any;

    /**
     * Job creation time in UTC
     */
    created_at: Date;

    /**
     * Job completion time in UTC
     */
    completed_at: Date;

    /**
     * Linked ITSM workflow task ID, if any
     */
    workflow_task_id: string;

    /**
     * Actions available for this job, e.g. 'rerun'
     */
    job_actions: Array<string>;

    /**
     * User who initiated the job
     */
    created_by: string;

    /**
     * Terraform job log ID, if available
     */
    attachment_id: string;

    /**
     * Linked schedule ID, if this job was triggered by a schedule
     */
    schedule_id: string;

}
